import { authorizedPut } from './baseApiService';

const resource = 'Filter';

export async function setFilters(searchParams?: URLSearchParams): Promise<void> {
  return await authorizedPut<void>(`${resource}?${searchParams ?? ''}`, {});
}
